const customerLoggedIn = theme.customer?.isLoggedIn;
const customerId = theme.customer?.id;

export const CONSTANTS = {
  LOCAL_STORAGE_WISHLIST_KEY: 'wishlist',
  LOCAL_STORAGE_DELIMITER: ',',
  BUTTON_ACTIVE_CLASS: 'is-active',
  CUSTOMER_LOGGED_IN: customerLoggedIn,
  CUSTOMER_ID: customerId,
  ALL_WISHLIST_URL: customerId ? `http://netlify.blacklemon.dk/.netlify/functions/getCustomerWishlistProducts?store=menuspace&customerId=${customerId}` : '',
  UPDATE_WISHLIST_URL: customerId ? `http://netlify.blacklemon.dk/.netlify/functions/updateCustomerWishlist?store=menuspace&customerId=${customerId}` : '',
};

export const SELECTORS = {
  WISHLIST_REMOVE_CONFIRMATION_WRAPPER: '.remove-wishlist-confirmation',
  WISHLIST_REMOVE_CONFIRMATION_CONFIRM: '.remove-wishlist-confirmation--confirm',
  WISHLIST_REMOVE_CONFIRMATION_CANCEL: '.remove-wishlist-confirmation--cancel',
  WISHLIST_EMPTY: '.wishlist__empty',
  WISHLIST_GRID: '.wishlist__grid',
  WISHLIST_GRID_WRAPPER: '.wishlist__grid--wrapper',
};

export function getLocalWishlist() {
  const wishlist = localStorage.getItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist ? wishlist.split(CONSTANTS.LOCAL_STORAGE_DELIMITER) : [];
}

export async function removeWishlist(handle) {
  const wishlist = localStorage.getItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY);
  const wishlistArray = wishlist ? wishlist.split(CONSTANTS.LOCAL_STORAGE_DELIMITER) : [];
  const productIndex = wishlistArray.indexOf(handle);

  if (productIndex !== -1) {
    wishlistArray.splice(productIndex, 1);
    const wishlistString = wishlistArray.join(CONSTANTS.LOCAL_STORAGE_DELIMITER);
    localStorage.setItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY, wishlistString);

    const event = new CustomEvent('wishlist:removed', {
      detail: {
        handle,
      },
    });
    document.dispatchEvent(event);
  }
}

export async function fetchRemoteWishlist() {
  if (!CONSTANTS.CUSTOMER_LOGGED_IN) return [];
  try {
    const res = await fetch(CONSTANTS.ALL_WISHLIST_URL);
    const data = await res.json();
    const products = data.metafield.value;
    return products;
  } catch (error) {
    console.error('[Wishlist] Failed to fetch wishlist', error);
    return [];
  }
}

export async function getProductGidByHandle(handle) {
  try {
    const res = await fetch(`/products/${handle}.json`);
    if (res.ok) {
      const data = await res.json();
      const productId = data.product?.id;
      if (productId) return `gid://shopify/Product/${productId}`;
    } else {
      await removeWishlist(handle);
      console.info('[Wishlist] Product handle removed: ', handle);
      return null;
    }
  } catch (error) {
    console.error('[Wishlist] Failed to fetch product id', error);
    return null;
  }
}

export async function updateRemoteWishlist(gid) {
  if (!CONSTANTS.CUSTOMER_LOGGED_IN) return [];
  try {
    const res = await fetch(CONSTANTS.UPDATE_WISHLIST_URL, {
      method: 'POST',
      body: gid,
    });
    const data = await res.json();
    const products = data.metafield.value;
    return products;
  } catch (error) {
    console.error('[Wishlist] Failed to update wishlist', error);
    return [];
  }
}